const C = {
  name: "Shanghai",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 0V5.12602C14.7252 5.57006 16 7.13616 16 9C16 10.0144 15.6224 10.9407 15 11.6458V17.8034C16.793 18.8412 18 20.7804 18 23V24H16V23C16 20.7923 14.2077 19 12 19C9.79228 19 8 20.7923 8 23V24H6V23C6 20.7804 7.20695 18.8412 9 17.8034V11.6458C8.37764 10.9407 8 10.0144 8 9C8 7.13616 9.27477 5.57006 11 5.12602V0H13ZM11 16V17.0831C11.3252 17.0284 11.6593 17 12 17C12.3407 17 12.6748 17.0284 13 17.0831V16H11ZM13 14V12.874C12.6804 12.9562 12.3453 13 12 13C11.6547 13 11.3196 12.9562 11 12.874V14H13ZM10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Shanghai
};
